import React from 'react';
import type { PeticeOvmDto } from '@gov-nx/api';
import { usePetitionAddresseeAutocomplete } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { petitionAddresseeTemplateResolver } from '@gov-nx/ui/types';
import type { FormAutocompleteProps } from '../FormAutocomplete';
import { FormAutocomplete } from '../FormAutocomplete';

interface Props extends Omit<FormAutocompleteProps<PeticeOvmDto>, 'field'> {
	field: Omit<
		FormAutocompleteProps<PeticeOvmDto>['field'],
		'templateResolver' | 'keyResolver' | 'valueResolver' | 'searchCallback'
	>;
}

export const PetitionAddresseeAutocomplete = (props: Props) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(LocalizeNameSpaceTypes.Form);
	const { searchCallback } = usePetitionAddresseeAutocomplete();

	return (
		<FormAutocomplete<PeticeOvmDto>
			label={props.label}
			field={{
				...props.field,
				messageEmpty:
					props.field.messageEmpty ?? tn('naseptavac.pole.zadny-vysledek'),
				templateResolver: petitionAddresseeTemplateResolver,
				keyResolver: (item) => item.datovaSchrankaId ?? '',
				valueResolver: petitionAddresseeTemplateResolver,
				searchCallback,
			}}
		/>
	);
};
